module.exports = __webpack_public_path__ + "static/media/09_5_WHEEL_Team-HKUST-wheels_AlessandroDellaBella_036.c2591921.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle09/09_5_WHEEL_Team-HKUST-wheels_AlessandroDellaBella_036.jpg
 ** module id = 145
 ** module chunks = 0
 **/